var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewListShowing),expression:"!isNewListShowing"}],attrs:{"id":"boards-create-list","data-testid":"boards-create-list","variant":"default"},on:{"click":_vm.handleClick}},[_c('gl-icon',{attrs:{"name":"plus","size":16}}),_vm._v("\n  "+_vm._s(_vm.__('New list'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }